export { default } from './GalleryPlaceholder';
